import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/zh-cn/blog/tag/$tag")({
  head: ({ params }) => buildRouteHead(`/zh-cn/blog/tag/${params.tag}`),
  component: Blog,
});

